import { render, staticRenderFns } from "./EditionSelect.vue?vue&type=template&id=68edce33&"
import script from "./EditionSelect.vue?vue&type=script&lang=js&"
export * from "./EditionSelect.vue?vue&type=script&lang=js&"
import style0 from "./EditionSelect.vue?vue&type=style&index=0&id=68edce33&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports